module.exports = __webpack_public_path__ + "assets/img/text-benefit.72efb12a.svg";